import { PublicLayout } from "@/components/PublicLayout";

const SECTIONS = [
  {
    h: "1. General Information",
    body: [
      "By enrolling in any Fun-Nastix programme or subscribing to one of our pricing plans, you agree to the terms and conditions outlined below. These terms ensure transparency, fairness, and clarity for all participants.",
    ],
  },
  {
    h: "2. Payment Policy",
    list: [
      "The cost of each session is £7.50.",
      "Payments are collected monthly over 11 months: September, October, November, December, January, February, March, April, May, June, and July.",
      "No payments are collected in August.",
      "August is considered part of the summer holidays; no classes will take place during this month.",
      "Sessions run during term time from September through to July, with the monthly payments spread evenly across these 11 months.",
      "Monthly pricing is based on the number of scheduled sessions across the academic year and divided evenly into 11 monthly payments.",
    ],
  },
  {
    h: "3. Cancellation Policy",
    list: [
      "A minimum of 30 days' notice is required to cancel any pricing plan.",
      "Notice must be given in writing via email to admin@fun-nastix.co.uk.",
      "During the 30-day notice period, any outstanding monthly fees must still be paid in full.",
      "Failure to make payment may result in loss of access to the class and future enrolment.",
    ],
  },
  {
    h: "4. Attendance Requirement",
    list: [
      "By subscribing, you confirm that your child attends the school where the Fun-Nastix sessions are delivered.",
      "These school-specific sessions are only available to pupils enrolled at the respective school.",
    ],
  },
  {
    h: "5. Assumption of Risk",
    list: [
      "Gymnastics is a physical activity that carries inherent risks, including the risk of minor or more serious injury.",
      "By enrolling, you acknowledge these risks and accept full responsibility for your child's participation.",
      "Fun-Nastix and its instructors will take all reasonable care to ensure safety but are not liable for any injuries sustained during sessions, except in cases of proven negligence.",
    ],
  },
  {
    h: "6. Behaviour and Conduct",
    list: [
      "Children are expected to behave respectfully and safely during sessions.",
      "Fun-Nastix reserves the right to remove a child from a class if behaviour is deemed disruptive or unsafe.",
    ],
  },
  {
    h: "7. Data and Communication",
    list: [
      "By subscribing, you consent to us contacting you via email for service updates and relevant information.",
      "You may also opt-in separately to receive promotional emails. You can unsubscribe at any time by clicking the link in any email or contacting us at admin@fun-nastix.co.uk.",
    ],
  },
  {
    h: "8. Changes to Terms",
    body: [
      "Fun-Nastix reserves the right to update these Terms and Conditions at any time. Any changes will be communicated in writing or published on our website.",
    ],
  },
];

export default function Terms() {
  return (
    <PublicLayout>
      <div className="bg-primary text-white py-12 px-4 text-center">
        <h1 className="font-display text-5xl uppercase">Terms &amp; Conditions</h1>
        <p className="mt-3 text-white/90">Fun-Nastix (Updated July 2025)</p>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="rounded-3xl border border-border p-6 sm:p-8 text-sm text-slate-600 space-y-1 mb-10">
          <p className="font-semibold text-slate-800">Fun-Nastix</p>
          <p>54 Warsash Road, Warsash, Southampton, SO31 9JA</p>
          <p>Tel: 07977 440 009 · Email: admin@fun-nastix.co.uk</p>
        </div>

        <div className="space-y-10">
          {SECTIONS.map((s, i) => (
            <div key={i} data-testid={`terms-${i}`}>
              <h2 className="font-display text-2xl text-primary">{s.h}</h2>
              {s.body && s.body.map((p, j) => (
                <p key={j} className="mt-2 text-slate-700 leading-relaxed">{p}</p>
              ))}
              {s.list && (
                <ul className="mt-3 space-y-2 list-disc pl-5 text-slate-700 leading-relaxed">
                  {s.list.map((li, j) => <li key={j}>{li}</li>)}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
